import { createSelector } from 'reselect';

const selectPaymentHistories = (state: any) => state.paymentHistories;

export const selectPaymentHistoriesCurrentItem = createSelector([selectPaymentHistories], (paymentHistories) => paymentHistories.current);

export const selectPaymentHistoriesListItems = createSelector([selectPaymentHistories], (paymentHistories) => paymentHistories.list);

export const selectPaymentHistoriesItemById = (itemId: any) =>
    createSelector(selectPaymentHistoriesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectPaymentHistoriesQueryItems = createSelector([selectPaymentHistories], (paymentHistories) => paymentHistories.query);

export const selectPaymentHistoriesCreatedItem = createSelector([selectPaymentHistories], (paymentHistories) => paymentHistories.create);

export const selectPaymentHistoriesUpdatedItem = createSelector([selectPaymentHistories], (paymentHistories) => paymentHistories.update);

export const selectPaymentHistoriesReadItem = createSelector([selectPaymentHistories], (paymentHistories) => paymentHistories.read);

export const selectPaymentHistoriesDeletedItem = createSelector([selectPaymentHistories], (paymentHistories) => paymentHistories.delete);

export const selectPaymentHistoriesSearchedItems = createSelector([selectPaymentHistories], (paymentHistories) => paymentHistories.search);

export const selectPaymentHistoriesItemsCount = createSelector([selectPaymentHistories], (paymentHistories) => paymentHistories.count);

export const selectPaymentHistoriesItemsFilter = createSelector([selectPaymentHistories], (paymentHistories) => paymentHistories.filter);